import * as yup from 'yup';
import { validateDateFutureOrNot } from '../../../shared/utils/functions';
import { translate } from '../../../shared/i18n';

export const schemaClientHealthCertificate = yup.object().shape({
  start_time: yup
    .string()
    .required(
      translate('healthCertificateCreateEdit.validation.startTimeRequired'),
    ),
  end_time: yup
    .string()
    .required(
      translate('healthCertificateCreateEdit.validation.endTimeRequired'),
    ),
  date: yup
    .string()
    .test(
      'test-date',
      translate('healthCertificateCreateEdit.validation.futureDate'),
      (date) => validateDateFutureOrNot(date),
    )
    .required(translate('healthCertificateCreateEdit.validation.dateRequired')),
  client_id: yup
    .string()
    .required(
      translate('healthCertificateCreateEdit.validation.clientRequired'),
    ),
  professional_id: yup
    .string()
    .required(
      translate('healthCertificateCreateEdit.validation.professionalRequired'),
    ),
  health_certificate_id: yup
    .string()
    .required(
      translate('healthCertificateCreateEdit.validation.modelRequired'),
    ),
  text_description: yup
    .string()
    .required(translate('healthCertificateCreateEdit.validation.textRequired')),
});
